(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-collapsible-content"] && !window.DesignMode) return;
  try {
    
    class Accordion {
      constructor(el) {
        // Store the <details> element
        this.el = el;
        // Store the <summary> element
        this.summary = el.querySelector('summary');
        // Store the <div class="accordion__content"> element
        this.content = el.querySelector('.accordion__content');
    
        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
        // Detect user clicks on the summary element
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
    
      onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.el.open) {
          this.open();
        // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
    
      shrink() {
        // Set the element as "being closed"
        this.isClosing = true;
        
        // Store the current height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;
        
        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }
        
        // Start a WAAPI animation
        this.animation = this.el.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          easing: 'ease-out'
        });
        
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => this.isClosing = false;
      }
    
      open() {
        // Apply a fixed height on the element
        this.el.style.height = `${this.el.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.el.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(() => this.expand());
      }
    
      expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
        
        // If there is already an animation running
        if (this.animation) {
          // Cancel the current animation
          this.animation.cancel();
        }
        
        // Start a WAAPI animation
        this.animation = this.el.animate({
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          easing: 'ease-out'
        });
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => this.isExpanding = false;
      }
    
      onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.el.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        this.el.style.height = this.el.style.overflow = '';
      }
    }
    
    document.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-ethos"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
    const readMoreButtons = document.querySelectorAll('.ethos-section__read-more');
    readMoreButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        const expandedText = event.target.previousElementSibling;
        expandedText.style.display = expandedText.style.display === 'none' ? 'block' : 'none';
        event.target.textContent = event.target.textContent === 'Read More' ? 'Read Less' : 'Read More';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-featured-collection-dropdown"] && !window.DesignMode) return;
  try {
    
// Get the dropdown and content divs
const dropdown = document.getElementById('collection-dropdown');
const divs = document.querySelectorAll('.ae-collection-dropdown');
const links = document.querySelectorAll('.ae-collection-dropdown-link');

// Function to show the selected div and hide others
function toggleDivs(selectedValue) {
  divs.forEach(div => {
    // Remove 'active' class from all divs and add it to the selected one
    div.classList.remove('ae-active');
    if (div.id === selectedValue) {
      div.classList.add('ae-active');
    }
  });
  links.forEach(link => {
    // Remove 'active' class from all divs and add it to the selected one
    link.classList.remove('ae-active-link');
    div_id = link.id.replace("Link-", "");
    if (div_id === selectedValue) {
      link.classList.add('ae-active-link');
    }
  });
}

// Add event listener to the dropdown
dropdown.addEventListener('change', function() {
  toggleDivs(this.value);
});

// Set the default div to be active based on the initially selected value
toggleDivs(dropdown.value);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !window.DesignMode) return;
  try {
    
  // var standardShippingThreshold = {{ threshold }} / 100;
  // var expressShippingThreshold = {{ express_threshold }};


  // function updateFreeShippingText(cartValue) {
  //   var freeShippingText = document.getElementById('free-shipping-text');
  //   var remaining_value = standardShippingThreshold - cartValue;
  //   var remaining_value_express = expressShippingThreshold - cartValue;
  //   // Update the inner HTML of the #free-shipping-text element based on the cart value
  //   if (cartValue >= expressShippingThreshold) {
  //     freeShippingText.innerHTML = 'Congratulations! You qualify for free express shipping';
  //   } else if (cartValue >= standardShippingThreshold && cartValue < expressShippingThreshold) {
  //     freeShippingText.innerHTML = 'Congratulations! You qualify for free standard shipping - Add $' + remaining_value_express + ' for free Express Shipping';
  //   } else if (cartValue == 0) {
  //     freeShippingText.innerHTML = 'Spend $' + remaining_value + ' to qualify for free Standard Shipping';
  //   } else {
  //     freeShippingText.innerHTML = 'Add $' + remaining_value + ' to qualify for free Standard Shipping';
  //   }
  // }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);  

  } catch(e) { console.error(e); }
})();
})();
